import { ThemeProvider } from "@emotion/react";
import { createTheme, TextField } from "@mui/material";
import React from "react";
import { colors } from "../../common/pallette/colors";

export const NumberFieldWithoutBorders = (props:any) => {
    const { value, handleChange, placeholder, manageOnBlur, fontSize, fontWeight, fullWidth } = props;
    
    const theme = createTheme({
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused": {
                backgroundColor: colors.grey.bright,
              },
              color: colors.black.dark,
            },
            input: {
                padding: '6px',
                fontSize: fontSize ? fontSize : '12px',
                fontWeight: fontWeight ? fontWeight : 400,
                color: colors.black.dark,
                "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                  display: "none",
                },
                "-moz-appearance": "textfield",
            }
          },
        },
      },
    });
    
    return(
        <ThemeProvider theme={theme}>
            <TextField
              type="number"
              fullWidth={fullWidth}
              value={value ? value : ''}
              onChange={handleChange}
              placeholder={placeholder}
              onBlur={manageOnBlur}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
        </ThemeProvider>
    );
};
